/**
 * Object Interface
 */

export interface ObjectInterface {
  longitude: number;
  latitude: number;
  category: string | null;
  /* eslint-disable-next-line */
  cm_id: string;
  name: string | null;
  description: string | null;
  url: string | null;
}

/*
 Modify Lat Long to suit x, y coordinates
*/
const numericRegex = /[^0-9.-]/g;

export const ensureCoordinates = (item: ObjectInterface): ObjectInterface => {
  const latStr = String(item.latitude);
  const lngStr = String(item.longitude);

  let lat = parseFloat(latStr.match(/[^0-9.-]/) ? latStr.replace(numericRegex, '') : latStr);
  let lng = parseFloat(lngStr.match(/[^0-9.-]/) ? lngStr.replace(numericRegex, '') : lngStr);

  lat = isNaN(lat) ? 0 : lat;
  lng = isNaN(lng) ? 0 : lng;

  return {
    ...item,
    latitude: lat > 0 ? (lat * -1) : Math.abs(lat),
    longitude: lng
  }
}
